<div class="dashboard-top-section d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center gap-2">
    <button class="back-button" [title]="'serviceLibrary.back' | transloco" (click)="onBackButtonClick()">
      <span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z" fill="#9FA1A4"/>
        </svg>
      </span>
    </button>
    <h1> {{ schedule.name }} </h1>
  </div>

  <div class="d-flex align-items-center gap-2">
    @if (schedule.serviceScheduleTypeId !== ScheduleType.Custom) {
      <span ngbDropdown class="service-library-filters" [autoClose]="true">
        <button type="button" class="btn service-library-filters form-control dropdown-toggle search-input" id="modelFilterDropdown"
          [disabled]="isLoadingModels" ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle filter-label" [class.is-selected]="!!selectedModel">{{ isLoadingModels ? ('serviceLibrary.filterPage.loading' | transloco) : modelLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="modelFilterDropdown">
          <div class="d-flex flex-column">
            @for (model of models; track model.id) {
              <button class="btn btn-outline" ngbDropdownItem (click)="onSelectModel(model)">{{ model.name }}</button>
            }
          </div>
        </div>
      </span>
      <span ngbDropdown class="service-library-filters" [autoClose]="true">
        <button type="button" class="btn service-library-filters form-control dropdown-toggle search-input" id="yearFilterDropdown" 
          [disabled]="yearDisabled || isLoadingYears" [attr.aria-disabled]="yearDisabled" ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle filter-label" [class.is-selected]="selectedYear != null">{{ isLoadingYears ? ('serviceLibrary.filterPage.loading' | transloco) : yearLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="yearFilterDropdown">
          <div class="d-flex flex-column">
            @for (year of years; track year) {
              <button class="btn btn-outline" ngbDropdownItem (click)="onSelectYear(year)">{{ year }}</button>
            }
          </div>
        </div>
      </span>
    }
    <span ngbDropdown class="service-library-filters service-type" [autoClose]="true">
      <button type="button" class="btn service-library-filters form-control dropdown-toggle search-input"  id="serviceTypeFilterDropdown"
        [disabled]="serviceTypeDisabled || isLoadingServiceTypes" [attr.aria-disabled]="serviceTypeDisabled" ngbDropdownToggle>
        <div class="d-flex flex-row justify-content-between dropdown-inner">
          <span class="align-middle filter-label" [class.is-selected]="selectedServiceType != null">{{ isLoadingServiceTypes ? ('serviceLibrary.filterPage.loading' | transloco) : serviceTypeLabel }}</span>
          <i class="ph ph-caret-down lh-base"></i>
        </div>
      </button>
      <div ngbDropdownMenu aria-labelledby="serviceTypeFilterDropdown">
        <div class="d-flex flex-column drop-down">
          @for (serviceType of serviceTypeOptions; track serviceType.value) {
            <button class="btn btn-outline" ngbDropdownItem (click)="onSelectServiceType(serviceType.value)">{{ serviceType.label | transloco }}</button>
          }
        </div>
      </div>
    </span>
    @if (schedule.serviceScheduleTypeId === ScheduleType.Custom) {
      <div class="header-actions">
        <button class="edit-button" (click)="openCreateMaintenancePlanModal()">
          <span class="edit-button-text">{{ 'serviceLibrary.edit' | transloco }}</span>
        </button>
      </div>
    }
  </div>
</div>
<div class="bottom-grid-section">
  <div class="bottom-grid-sec-left">
    @if (!isLoading) {
      @if (hasError) {
        <div class="error-container d-flex align-items-center justify-content-center">
          <app-empty-state [message]="errorMessage"></app-empty-state>
        </div>
      } @else if (serviceDetails) {
        <div class="truck-image">
          @if (schedule.serviceScheduleTypeId === ScheduleType.Custom) {
            <img [src]="customOverlayImage" [attr.alt]="'serviceLibrary.assetPhotoAlt' | transloco" />
          } @else {
            <img [src]="schedule.imageUrl" [attr.alt]="'serviceLibrary.assetPhotoAlt' | transloco" />
          }
        </div>
        <div class="details-row">
          <div class="details-card">
            <div class="body-wrapper">
              <div class="card-header">
                <span class="card-header-title">{{ 'serviceLibrary.details.serviceDetails' | transloco }}</span>
              </div>
              <div class="details-body">
                <div class="details-item">
                  <div class="details-label">{{ 'serviceLibrary.details.serviceName' | transloco }}</div>
                  <div class="details-value">{{ serviceDetails.serviceName }}</div>
                </div>
                <div class="details-item">
                  <div class="details-label">{{ 'serviceLibrary.details.serviceType' | transloco }}</div>
                  <div class="details-value">{{ serviceType }}</div>
                </div>
              </div>
              <div class="card-header">
                <span class="card-header-title">{{ 'serviceLibrary.details.triggerRule' | transloco }}</span>
              </div>
              <div class="details-body">
                <div class="details-item">
                  <div class="details-label">{{ 'serviceLibrary.details.timeInterval' | transloco }}</div>
                  <div class="details-value">{{ serviceDetails.timeInterval ?? '-' }}</div>
                </div>
                <div class="details-item">
                  <div class="details-label">{{ 'serviceLibrary.details.usageInterval' | transloco }}</div>
                  <div class="details-value">{{ serviceDetails.usageInterval ?? '-'}}</div>
                </div>
                <div class="details-item">
                  <div class="details-label">{{ 'serviceLibrary.details.estimatedDowntime' | transloco }}</div>
                  <div class="details-value">{{ serviceDetails.estimatedDowntime > 0 ? serviceDetails.estimatedDowntime + ' ' + ('workOrder.table.hrs' | transloco)  : '-'}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="parts-card">
            <div class="card-header">
              <span class="card-header-title">{{ 'serviceLibrary.details.partsRequired' | transloco }}</span>
            </div>
            <div class="body-wrapper">
              <div class="parts-body">
                <div class="parts-list">
                  @if (serviceDetails.parts.length) {
                    @for (part of serviceDetails.parts; track part.id) {
                      <span class="part-chip">{{ part.name }}</span>
                    }
                  } @else {
                    <div class="d-flex flex-column gap-2 align-items-center justify-content-center h-100 w-100">
                      <span class="parts-empty">{{ 'serviceLibrary.details.noParts' | transloco }}</span>
                    </div>
                  }
                  @if (schedule.serviceScheduleTypeId === ScheduleType.Custom) {
                    <span class="add-part-chip">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="openSelectPartsModal(); $event.stopPropagation()">
                        <path d="M12.6654 7.33594H8.66536V3.33594H7.33203V7.33594H3.33203V8.66927H7.33203V12.6693H8.66536V8.66927H12.6654V7.33594Z" fill="#9FA1A4"/>
                      </svg>
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="spinner-container d-flex align-items-center justify-content-center spinner-border"></div>
    }  
  </div>
</div>